var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sortable-list-thumb-wrap"},[(_vm.trackError)?_c('img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"aria-hidden":"true","src":_vm.src},on:{"error":_vm.onLoadError}}):_vm._e(),_c('div',{staticClass:"sortable-list-thumb",style:(_vm.thumbStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }